import Vue from 'vue'
import VueRouter from 'vue-router'

import EscapeTop from '@/components/EscapeTop'
import EscapeEdit from '@/components/EscapeEdit'
import UserShow from '@/components/UserShow'
import Sign from '@/components/Sign'

Vue.use(VueRouter);

export default new VueRouter({
  routes: [
    {
      path: '/',
      name: 'top',
      component: EscapeTop
    },
    {
      path: '/users/:userId/edit',
      name: 'edit',
      component: EscapeEdit,
      props: route => ({ userId: route.params.userId })
    },
    {
      path: '/users/:userId',
      name: 'show',
      component: UserShow,
      props: route => ({ userId: route.params.userId })
    },
    {
      path: '/sign',
      name: 'sign',
      component: Sign
    }
  ]
})